import React from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';
import TrailResultCardShimmer from '../TrailResultCardShimmer';

const TrailRiverShimmer = ({ className }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.innerContainer}>
        <div className={styles.title} />
        <div className={styles.river}>
          <TrailResultCardShimmer />
          <TrailResultCardShimmer />
          <TrailResultCardShimmer />
          <TrailResultCardShimmer />
        </div>
      </div>
    </div>
  );
};

TrailRiverShimmer.propTypes = {
  className: string
};

TrailRiverShimmer.defaultProps = {
  className: ''
};

export default TrailRiverShimmer;
